// common type

export const ME_GET = 'ME_GET';
export const ME_RESET = 'ME_RESET';

export const USER_ALL = 'USER_ALL';
export const USER_GET = 'USER_GET';
export const USER_POST = 'USER_POST';
export const USER_PUT = 'USER_PUT';
export const USER_DEL = 'USER_DEL';
export const USER_CREATE = 'USER_CREATE';
export const USER_LOADING = 'USER_LOADING';
export const USER_ERROR = 'USER_ERROR';

// feature type
export const ROLE_ALL = 'ROLE_ALL';
export const ROLE_GET = 'ROLE_GET';
export const ROLE_POST = 'ROLE_POST';
export const ROLE_PUT = 'ROLE_PUT';
export const ROLE_DEL = 'ROLE_DEL';
export const ROLE_LOADING = 'ROLE_LOADING';
export const ROLE_ERROR = 'ROLE_ERROR';

export const ROLETYPES_ALL = 'ROLETYPES_ALL';
export const ROLETYPES_GET = 'ROLETYPES_GET';
export const ROLETYPES_POST = 'ROLETYPES_POST';
export const ROLETYPES_PUT = 'ROLETYPES_PUT';
export const ROLETYPES_DEL = 'ROLETYPES_DEL';
export const ROLETYPES_LOADING = 'ROLETYPES_LOADING';
export const ROLETYPES_ERROR = 'ROLETYPES_ERROR';

export const EMPLOYEE_ALL = 'EMPLOYEE_ALL';
export const EMPLOYEE_GET = 'EMPLOYEE_GET';
export const EMPLOYEE_POST = 'EMPLOYEE_POST';
export const EMPLOYEE_PUT = 'EMPLOYEE_PUT';
export const EMPLOYEE_DEL = 'EMPLOYEE_DEL';
export const EMPLOYEE_RESET = 'EMPLOYEE_RESET';
export const EMPLOYEE_LOADING = 'EMPLOYEE_LOADING';
export const EMPLOYEE_ERROR = 'EMPLOYEE_ERROR';
export const EMPLOYEE_PENDING_COUNT = 'EMPLOYEE_PENDING_COUNT';

export const DROPLET_PROJECT_ALL = 'DROPLET_PROJECT_ALL';
export const DROPLET_PROJECT_GET = 'DROPLET_PROJECT_GET';
export const DROPLET_PROJECT_POST = 'DROPLET_PROJECT_POST';
export const DROPLET_PROJECT_PUT = 'DROPLET_PROJECT_PUT';
export const DROPLET_PROJECT_DEL = 'DROPLET_PROJECT_DEL';
export const DROPLET_PROJECT_ERROR = 'DROPLET_PROJECT_ERROR';
export const DROPLET_PROJECT_LOADING = 'DROPLET_PROJECT_LOADING';

export const DROPLET_ALL = 'DROPLET_ALL';
export const DROPLET_GET = 'DROPLET_GET';
export const DROPLET_POST = 'DROPLET_POST';
export const DROPLET_PUT = 'DROPLET_PUT';
export const DROPLET_DEL = 'DROPLET_DEL';
export const DROPLET_ERROR = 'DROPLET_ERROR';
export const DROPLET_LOADING = 'DROPLET_LOADING';

export const PROJECT_ALL = 'PROJECT_ALL';
export const PROJECT_GET = 'PROJECT_GET';
export const PROJECT_POST = 'PROJECT_POST';
export const PROJECT_PUT = 'PROJECT_PUT';
export const PROJECT_DEL = 'PROJECT_DEL';
export const PROJECT_ERROR = 'PROJECT_ERROR';
export const PROJECT_LOADING = 'PROJECT_LOADING';
export const PROJECT_RESET = 'PROJECT_RESET';

export const SYSTEM_ALL = 'SYSTEM_ALL';
export const SYSTEM_GET = 'SYSTEM_GET';
export const SYSTEM_POST = 'SYSTEM_POST';
export const SYSTEM_PUT = 'SYSTEM_PUT';
export const SYSTEM_DEL = 'SYSTEM_DEL';
export const SYSTEM_ERROR = 'SYSTEM_ERROR';
export const SYSTEM_LOADING = 'SYSTEM_LOADING';

export const BUDGET_ALL = 'BUDGET_ALL';
export const BUDGET_GET = 'BUDGET_GET';
export const BUDGET_POST = 'BUDGET_POST';
export const BUDGET_PUT = 'BUDGET_PUT';
export const BUDGET_DEL = 'BUDGET_DEL';
export const BUDGET_ERROR = 'BUDGET_ERROR';
export const BUDGET_LOADING = 'BUDGET_LOADING';
export const BUDGET_RESET = 'BUDGET_RESET';

export const EXPENSES_ALL = 'EXPENSES_ALL';
export const EXPENSES_MERGE = 'EXPENSES_MERGE';
export const EXPENSES_GET = 'EXPENSES_GET';
export const EXPENSES_POST = 'EXPENSES_POST';
export const EXPENSES_PUT = 'EXPENSES_PUT';
export const EXPENSES_DEL = 'EXPENSES_DEL';
export const EXPENSES_ERROR = 'EXPENSES_ERROR';
export const EXPENSES_LOADING = 'EXPENSES_LOADING';
export const EXPENSES_RESET = 'EXPENSES_RESET';
export const EXPENSES_PENDING_COUNT = 'EXPENSES_PENDING_COUNT';
export const EXPENSES_PAYMENT_APPROVAL_PENDING_COUNT = 'EXPENSES_PAYMENT_APPROVAL_PENDING_COUNT';
export const EXPENSES_REVIEW_PENDING_COUNT = 'EXPENSES_REVIEW_PENDING_COUNT';

export const INFORMATION_ALL = 'INFORMATION_ALL';
export const INFORMATION_PUT = 'INFORMATION_PUT';
export const INFORMATION_LOADING = 'INFORMATION_LOADING';
export const INFORMATION_ERROR = 'INFORMATION_ERROR';

export const NOTIFY_REQ_TOKEN = 'NOTIFY_REQ_TOKEN';
export const NOTIFY_DIRECT = 'NOTIFY_DIRECT';
export const NOTIFY_DEPARTMENT = 'NOTIFY_DEPARTMENT';
export const NOTIFY_LOADING = 'NOTIFY_LOADING';
export const NOTIFY_ERROR = 'NOTIFY_ERROR';

export const INFO_GET = 'INFO_GET';
export const INFO_CREATE = 'INFO_CREATE';
export const INFO_PUT = 'INFO_PUT';
export const INFO_RESET = 'INFO_RESET';
export const INFO_LOADING = 'INFO_LOADING';
export const INFO_ERROR = 'INFO_ERROR';

export const CUSTOMER_ALL = 'CUSTOMER_ALL';
export const CUSTOMER_GET = 'CUSTOMER_GET';
export const CUSTOMER_POST = 'CUSTOMER_POST';
export const CUSTOMER_PUT = 'CUSTOMER_PUT';
export const CUSTOMER_DEL = 'CUSTOMER_DEL';
export const CUSTOMER_RESET = 'CUSTOMER_RESET';
export const CUSTOMER_LOADING = 'CUSTOMER_LOADING';
export const CUSTOMER_ERROR = 'CUSTOMER_ERROR';

export const CUSTOMER_TYPE_ALL = 'CUSTOMER_TYPE_ALL';
export const CUSTOMER_TYPE_GET = 'CUSTOMER_TYPE_GET';
export const CUSTOMER_TYPE_POST = 'CUSTOMER_TYPE_POST';
export const CUSTOMER_TYPE_PUT = 'CUSTOMER_TYPE_PUT';
export const CUSTOMER_TYPE_DEL = 'CUSTOMER_TYPE_DEL';
export const CUSTOMER_TYPE_LOADING = 'CUSTOMER_TYPE_LOADING';
export const CUSTOMER_TYPE_ERROR = 'CUSTOMER_TYPE_ERROR';

export const DEPARTMENT_ALL = 'DEPARTMENT_ALL';
export const DEPARTMENT_GET = 'DEPARTMENT_GET';
export const DEPARTMENT_POST = 'DEPARTMENT_POST';
export const DEPARTMENT_PUT = 'DEPARTMENT_PUT';
export const DEPARTMENT_DEL = 'DEPARTMENT_DEL';
export const DEPARTMENT_LOADING = 'DEPARTMENT_LOADING';
export const DEPARTMENT_ERROR = 'DEPARTMENT_ERROR';

export const TIMESTAMP_ALL = 'TIMESTAMP_ALL';
export const TIMESTAMP_GET = 'TIMESTAMP_GET';
export const TIMESTAMP_POST = 'TIMESTAMP_POST';
export const TIMESTAMP_PUT = 'TIMESTAMP_PUT';
export const TIMESTAMP_DEL = 'TIMESTAMP_DEL';
export const TIMESTAMP_ERROR = 'TIMESTAMP_ERROR';
export const TIMESTAMP_LOADING = 'TIMESTAMP_LOADING';
export const TIMESTAMP_RESET = 'TIMESTAMP_RESET';
export const TIMESTAMP_PAYROLL_ALL = 'TIMESTAMP_PAYROLL_ALL';
export const TIMESTAMP_PENDING_APPROVAL_COUNT = 'TIMESTAMP_PENDING_APPROVAL_COUNT';

export const HOLIDAY_ALL = 'HOLIDAY_ALL';
export const HOLIDAY_GET = 'HOLIDAY_GET';
export const HOLIDAY_POST = 'HOLIDAY_POST';
export const HOLIDAY_PUT = 'HOLIDAY_PUT';
export const HOLIDAY_DEL = 'HOLIDAY_DEL';
export const HOLIDAY_LOADING = 'HOLIDAY_LOADING';
export const HOLIDAY_ERROR = 'HOLIDAY_ERROR';

export const BILLING_ALL = 'BILLING_ALL';
export const BILLING_GET = 'BILLING_GET';
export const BILLING_POST = 'BILLING_POST';
export const BILLING_PUT = 'BILLING_PUT';
export const BILLING_DEL = 'BILLING_DEL';
export const BILLING_LOADING = 'BILLING_LOADING';
export const BILLING_ERROR = 'BILLING_ERROR';
export const BILLING_RESET = 'BILLING_RESET';

export const PAYOUT_ALL = 'PAYOUT_ALL';
export const PAYOUT_GET = 'PAYOUT_GET';
export const PAYOUT_POST = 'PAYOUT_POST';
export const PAYOUT_PUT = 'PAYOUT_PUT';
export const PAYOUT_DEL = 'PAYOUT_DEL';
export const PAYOUT_LOADING = 'PAYOUT_LOADING';
export const PAYOUT_ERROR = 'PAYOUT_ERROR';
export const PAYOUT_RESET = 'PAYOUT_RESET';

export const PAYIN_ALL = 'PAYIN_ALL';
export const PAYIN_GET = 'PAYIN_GET';
export const PAYIN_POST = 'PAYIN_POST';
export const PAYIN_PUT = 'PAYIN_PUT';
export const PAYIN_DEL = 'PAYIN_DEL';
export const PAYIN_LOADING = 'PAYIN_LOADING';
export const PAYIN_ERROR = 'PAYIN_ERROR';
export const PAYIN_RESET = 'PAYIN_RESET';

export const PAYMENT_ALL = 'PAYMENT_ALL';
export const PAYMENT_GET = 'PAYMENT_GET';
export const PAYMENT_POST = 'PAYMENT_POST';
export const PAYMENT_PUT = 'PAYMENT_PUT';
export const PAYMENT_DEL = 'PAYMENT_DEL';
export const PAYMENT_LOADING = 'PAYMENT_LOADING';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const PAYMENT_RESET = 'PAYMENT_RESET';

export const PAYTYPE_ALL = 'PAYTYPE_ALL';
export const PAYTYPE_GET = 'PAYTYPE_GET';
export const PAYTYPE_POST = 'PAYTYPE_POST';
export const PAYTYPE_PUT = 'PAYTYPE_PUT';
export const PAYTYPE_DEL = 'PAYTYPE_DEL';
export const PAYTYPE_LOADING = 'PAYTYPE_LOADING';
export const PAYTYPE_ERROR = 'PAYTYPE_ERROR';
export const PAYTYPE_RESET = 'PAYTYPE_RESET';

export const TRANSECTIONTYPE_ALL = 'TRANSECTIONTYPE_ALL';
export const TRANSECTIONTYPE_GET = 'TRANSECTIONTYPE_GET';
export const TRANSECTIONTYPE_POST = 'TRANSECTIONTYPE_POST';
export const TRANSECTIONTYPE_PUT = 'TRANSECTIONTYPE_PUT';
export const TRANSECTIONTYPE_DEL = 'TRANSECTIONTYPE_DEL';
export const TRANSECTIONTYPE_LOADING = 'TRANSECTIONTYPE_LOADING';
export const TRANSECTIONTYPE_ERROR = 'TRANSECTIONTYPE_ERROR';
export const TRANSECTIONTYPE_RESET = 'TRANSECTIONTYPE_RESET';

export const SALARY_ALL = 'SALARY_ALL';
export const SALARY_GET = 'SALARY_GET';
export const SALARY_POST = 'SALARY_POST';
export const SALARY_PUT = 'SALARY_PUT';
export const SALARY_DEL = 'SALARY_DEL';
export const SALARY_LOADING = 'SALARY_LOADING';
export const SALARY_ERROR = 'SALARY_ERROR';
export const SALARY_RESET = 'SALARY_RESET';

export const SALARYLIST_ALL = 'SALARYLIST_ALL';
export const SALARYLIST_GET = 'SALARYLIST_GET';
export const SALARYLIST_POST = 'SALARYLIST_POST';
export const SALARYLIST_PUT = 'SALARYLIST_PUT';
export const SALARYLIST_DEL = 'SALARYLIST_DEL';
export const SALARYLIST_LOADING = 'SALARYLIST_LOADING';
export const SALARYLIST_ERROR = 'SALARYLIST_ERROR';
export const SALARYLIST_RESET = 'SALARYLIST_RESET';

// เก็บ "เงินเดือน 1 รายการ" (ผลจาก salaryListGet) แยก slice ออกจาก SALARYLIST_ALL/rows
// (state.salaryList) เพราะเดิมใช้ type เดียวกัน ทำให้เปิดหน้ารายละเอียด/modal ของ 1 รายการ
// แล้วไปทับ rows ของหน้ารายการทั้งหมดที่ยัง mount ค้างอยู่เบื้องหลัง (เช่น modal ที่เปิดจาก
// SalaryListTable) กลายเป็นว่าตารางรายการหลักโชว์ "ไม่พบข้อมูล" ทั้งที่ข้อมูลยังอยู่จริง
export const SALARY_DETAIL_GET = 'SALARY_DETAIL_GET';
export const SALARY_DETAIL_ERROR = 'SALARY_DETAIL_ERROR';
export const SALARY_DETAIL_RESET = 'SALARY_DETAIL_RESET';

export const OTREQUEST_ALL = 'OTREQUEST_ALL';
export const OTREQUEST_GET = 'OTREQUEST_GET';
export const OTREQUEST_POST = 'OTREQUEST_POST';
export const OTREQUEST_PUT = 'OTREQUEST_PUT';
export const OTREQUEST_DEL = 'OTREQUEST_DEL';
export const OTREQUEST_LOADING = 'OTREQUEST_LOADING';
export const OTREQUEST_ERROR = 'OTREQUEST_ERROR';
export const OTREQUEST_RESET = 'OTREQUEST_RESET';
export const OTREQUEST_PENDING_COUNT = 'OTREQUEST_PENDING_COUNT';

export const OTREQUESTORDER_ALL = 'OTREQUESTORDER_ALL';
export const OTREQUESTORDER_GET = 'OTREQUESTORDER_GET';
export const OTREQUESTORDER_POST = 'OTREQUESTORDER_POST';
export const OTREQUESTORDER_PUT = 'OTREQUESTORDER_PUT';
export const OTREQUESTORDER_DEL = 'OTREQUESTORDER_DEL';
export const OTREQUESTORDER_LOADING = 'OTREQUESTORDER_LOADING';
export const OTREQUESTORDER_ERROR = 'OTREQUESTORDER_ERROR';
export const OTREQUESTORDER_RESET = 'OTREQUESTORDER_RESET';

export const FIELDALLOWANCEREQUESTORDER_ALL = 'FIELDALLOWANCEREQUESTORDER_ALL';
export const FIELDALLOWANCEREQUESTORDER_GET = 'FIELDALLOWANCEREQUESTORDER_GET';
export const FIELDALLOWANCEREQUESTORDER_POST = 'FIELDALLOWANCEREQUESTORDER_POST';
export const FIELDALLOWANCEREQUESTORDER_PUT = 'FIELDALLOWANCEREQUESTORDER_PUT';
export const FIELDALLOWANCEREQUESTORDER_DEL = 'FIELDALLOWANCEREQUESTORDER_DEL';
export const FIELDALLOWANCEREQUESTORDER_LOADING = 'FIELDALLOWANCEREQUESTORDER_LOADING';
export const FIELDALLOWANCEREQUESTORDER_ERROR = 'FIELDALLOWANCEREQUESTORDER_ERROR';
export const FIELDALLOWANCEREQUESTORDER_PENDING_COUNT = 'FIELDALLOWANCEREQUESTORDER_PENDING_COUNT';

export const CHATEXPENSES_ALL = 'CHATEXPENSES_ALL';
export const CHATEXPENSES_GET = 'CHATEXPENSES_GET';
export const CHATEXPENSES_POST = 'CHATEXPENSES_POST';
export const CHATEXPENSES_PUT = 'CHATEXPENSES_PUT';
export const CHATEXPENSES_DEL = 'CHATEXPENSES_DEL';
export const CHATEXPENSES_LOADING = 'CHATEXPENSES_LOADING';
export const CHATEXPENSES_ERROR = 'CHATEXPENSES_ERROR';
export const CHATEXPENSES_RESET = 'CHATEXPENSES_RESET';

export const MANPOWER_ALL = 'MANPOWER_ALL';
export const MANPOWER_GET = 'MANPOWER_GET';
export const MANPOWER_POST = 'MANPOWER_POST';
export const MANPOWER_PUT = 'MANPOWER_PUT';
export const MANPOWER_DEL = 'MANPOWER_DEL';
export const MANPOWER_LOADING = 'MANPOWER_LOADING';
export const MANPOWER_ERROR = 'MANPOWER_ERROR';
export const MANPOWER_RESET = 'MANPOWER_RESET';

export const ACTIVITYLOG_ALL = 'ACTIVITYLOG_ALL';
export const ACTIVITYLOG_LOADING = 'ACTIVITYLOG_LOADING';
export const ACTIVITYLOG_ERROR = 'ACTIVITYLOG_ERROR';
export const ACTIVITYLOG_RESET = 'ACTIVITYLOG_RESET';

export const CONTACT_ALL = 'CONTACT_ALL';
export const CONTACT_GET = 'CONTACT_GET';
export const CONTACT_POST = 'CONTACT_POST';
export const CONTACT_PUT = 'CONTACT_PUT';
export const CONTACT_DEL = 'CONTACT_DEL';
export const CONTACT_RESET = 'CONTACT_RESET';
export const CONTACT_LOADING = 'CONTACT_LOADING';
export const CONTACT_ERROR = 'CONTACT_ERROR';

export const DOCUMENT_ALL = 'DOCUMENT_ALL';
export const DOCUMENT_GET = 'DOCUMENT_GET';
export const DOCUMENT_POST = 'DOCUMENT_POST';
export const DOCUMENT_PUT = 'DOCUMENT_PUT';
export const DOCUMENT_DEL = 'DOCUMENT_DEL';
export const DOCUMENT_RESET = 'DOCUMENT_RESET';
export const DOCUMENT_LOADING = 'DOCUMENT_LOADING';
export const DOCUMENT_ERROR = 'DOCUMENT_ERROR';

export const ITEM_TEMPLATE_ALL = 'ITEM_TEMPLATE_ALL';
export const ITEM_TEMPLATE_GET = 'ITEM_TEMPLATE_GET';
export const ITEM_TEMPLATE_POST = 'ITEM_TEMPLATE_POST';
export const ITEM_TEMPLATE_PUT = 'ITEM_TEMPLATE_PUT';
export const ITEM_TEMPLATE_DEL = 'ITEM_TEMPLATE_DEL';
export const ITEM_TEMPLATE_RESET = 'ITEM_TEMPLATE_RESET';
export const ITEM_TEMPLATE_LOADING = 'ITEM_TEMPLATE_LOADING';
export const ITEM_TEMPLATE_ERROR = 'ITEM_TEMPLATE_ERROR';

export const MANUAL_WORK_ALL = 'MANUAL_WORK_ALL';
export const MANUAL_WORK_POST = 'MANUAL_WORK_POST';
export const MANUAL_WORK_DEL = 'MANUAL_WORK_DEL';
export const MANUAL_WORK_LOADING = 'MANUAL_WORK_LOADING';
export const MANUAL_WORK_ERROR = 'MANUAL_WORK_ERROR';

export const PAYROLL_ADJ_ALL = 'PAYROLL_ADJ_ALL';
export const PAYROLL_ADJ_POST = 'PAYROLL_ADJ_POST';
export const PAYROLL_ADJ_LOADING = 'PAYROLL_ADJ_LOADING';
export const PAYROLL_ADJ_ERROR = 'PAYROLL_ADJ_ERROR';

export const PAYROLL_CARRYOVER_PERIOD = 'PAYROLL_CARRYOVER_PERIOD';
export const PAYROLL_CARRYOVER_LOADING = 'PAYROLL_CARRYOVER_LOADING';
export const PAYROLL_CARRYOVER_ERROR = 'PAYROLL_CARRYOVER_ERROR';

export const LEAVEREQUEST_ALL = 'LEAVEREQUEST_ALL';
export const LEAVEREQUEST_GET = 'LEAVEREQUEST_GET';
export const LEAVEREQUEST_POST = 'LEAVEREQUEST_POST';
export const LEAVEREQUEST_PUT = 'LEAVEREQUEST_PUT';
export const LEAVEREQUEST_DEL = 'LEAVEREQUEST_DEL';
export const LEAVEREQUEST_LOADING = 'LEAVEREQUEST_LOADING';
export const LEAVEREQUEST_ERROR = 'LEAVEREQUEST_ERROR';
export const LEAVEREQUEST_RESET = 'LEAVEREQUEST_RESET';
export const LEAVEREQUEST_PENDING_COUNT = 'LEAVEREQUEST_PENDING_COUNT';

export const VEHICLEFUELSETTING_GET = 'VEHICLEFUELSETTING_GET';
export const VEHICLEFUELSETTING_POST = 'VEHICLEFUELSETTING_POST';
export const VEHICLEFUELSETTING_PUT = 'VEHICLEFUELSETTING_PUT';
export const VEHICLEFUELSETTING_LOADING = 'VEHICLEFUELSETTING_LOADING';
export const VEHICLEFUELSETTING_ERROR = 'VEHICLEFUELSETTING_ERROR';
export const VEHICLEFUELSETTING_RESET = 'VEHICLEFUELSETTING_RESET';
